import { useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import Select from "react-select";
import lowerCase from "lodash/lowerCase";

import Fetching from "@/components/Fetching/Fetching";
import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

import { getDashboardPrices } from "@/api/Dashboard/dashboard";
import { dateToLocale, formatMilesDecimal } from "@/services/Utils";

import classes from "./dashboard-prices.module.scss";

const DashboardPrices = ({ filters, products }) => {
	const [textProduct, setTextProduct] = useState("");
	const [productId, setProductId] = useState("");

	const { estate_parent_id, estate_id, type_currency } = useSelector((state) => state.auth.filter);

	const { data, isLoading } = useQuery(["dashboard_prices", { ...filters, estate_parent_id, estate_id, type_currency, product_id: productId }], () =>
		getDashboardPrices({ ...filters, estate_parent_id, estate_id, type_currency, product_id: productId }),
	);

	return (
		<>
			{isLoading ? (
				<Fetching topMargin="5em" bottomMargin="5em" />
			) : (
				<>
					<div style={{ height: "12%", display: "flex" }}>
						<div style={{ width: "80%" }}>
							<Select
								value={products && products.filter((c) => Number(c.value) === Number(productId))}
								placeholder={<div>Seleccione Producto</div>}
								options={
									textProduct && textProduct.length > 2
										? products && products.filter((p) => lowerCase(p.label).includes(lowerCase(textProduct)))
										: []
								}
								onInputChange={(value) => {
									setTextProduct(value);
								}}
								onChange={(value) => {
									setProductId(value ? value.value : "");
								}}
								components={{
									NoOptionsMessage,
								}}
								isClearable
							/>
						</div>

						<div className={classes.div_price}>
							<small>Precio promedio (Kg/L/Un)</small>
							{data?.average?.AVERAGE ? (
								<span
									style={{
										fontSize: "15px",
										color: "#7fb02f",
										fontWeight: "600",
									}}
								>
									${formatMilesDecimal(data?.average?.AVERAGE)}
								</span>
							) : (
								"-"
							)}
						</div>
					</div>
					<div className={classes.style_table} style={{ height: "70%", overflowY: "auto" }}>
						<table className={classes.style_table_title}>
							<thead>
								<tr>
									<th className={classes.table_th} style={{ width: "15%" }}>
										Fecha
									</th>
									<th className={classes.table_th} style={{ width: "25%" }}>
										Distribuidor
									</th>
									<th className={classes.table_th} style={{ width: "30%" }}>
										Producto
									</th>
									<th className={classes.table_th} style={{ width: "10%" }}>
										Cant. Producto
									</th>
									<th className={classes.table_th} style={{ width: "20%" }}>
										Precio por (Kg/L/Un)
									</th>
								</tr>
							</thead>
						</table>
						{data &&
							data.prices &&
							data.prices.map((item, i) => {
								return (
									<table key={i} className={classes.style_table_body}>
										<tbody>
											<tr>
												<td style={{ width: "15%" }}>{dateToLocale(item.FECHA)}</td>
												<td style={{ width: "25%" }}>{item.PROVEEDOR}</td>
												<td style={{ width: "30%" }}>{item.PRODUCTO}</td>
												<td style={{ width: "10%" }}>
													{formatMilesDecimal(Number(item.CONTENIDO_KG) * Number(item.CANTIDAD_ENVASES))}
												</td>
												<td style={{ width: "30%" }}>{`$${formatMilesDecimal(item.PRECIO_POR_KG)}`}</td>
											</tr>
										</tbody>
									</table>
								);
							})}
					</div>
				</>
			)}
		</>
	);
};

export default DashboardPrices;
